import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import type { PositiveResponseCode } from "../interface"

const getPositiveResponseCodes = async (): Promise<
	| { success: true; response: { Data: PositiveResponseCode[] } }
	| { success: false; response: unknown }
> => {
	try {
		const response = await Axios.get(
			`${process.env.REACT_APP_API_URL}/api/positiveResponse/codes`,
			AxiosConfig.configValue("min"),
		)
		return {
			success: true,
			response: response.data as { Data: PositiveResponseCode[] },
		}
	} catch (error) {
		return { success: false, response: error }
	}
}

export default getPositiveResponseCodes
